<div class="my-4" *ngIf="control" [ngClass]="{ readonly: readonly }">
  <span class="d-flex">
    <p-inputSwitch [id]="componentId" [formControl]="control" (onChange)="changes.emit()"></p-inputSwitch>
    <span *ngIf="label" class="pl-3">{{ label | translate }}</span>
  </span>
</div>
